(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabActionsQueue', TabActionsQueue)
        .factory('TabActionsQueueRetry', TabActionsQueueRetry);

    TabActionsQueue.$inject = ['$resource', 'DateUtils'];

    function TabActionsQueue($resource, DateUtils) {
        var resourceUrl = 'api/tab-actions-queues/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.insertDateTime = DateUtils.convertDateTimeFromServer(data.insertDateTime);
                    data.executionDateTime = DateUtils.convertDateTimeFromServer(data.executionDateTime);
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'checkExpired' : {method: 'GET'},
            'getByAlias' : {
                url: 'api/tab-actions-queues/alias',
                method: 'GET',
                isArray: true
            },
            'getGroups' : {
                url: 'api/tab-actions-queues/groupList',
                method: 'GET',
                isArray: true
            }
        });
    }

    function TabActionsQueueRetry($resource, DateUtils) {
        var resourceUrl = 'api/tab-actions-queues/retry:id';

        return $resource(resourceUrl, {}, {
            'update': {method: 'PUT'}
        });
    }
})();
